import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5be5c7de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  ref: "infoModal",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Skicka in")
], -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = {
  class: "row",
  id: "shopping-list-wrapper"
}
const _hoisted_12 = { class: "table table-striped table-hover mb-0" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Vara"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Mängd"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Kommentar till butiken"),
      /*#__PURE__*/_createElementVNode("span", { class: "d-block d-md-none" }, "Kommentar")
    ])
  ])
], -1))
const _hoisted_14 = {
  key: 0,
  class: "form-group mt-2"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "shopping-list-comment" }, "Generell kommentar till butiken:", -1))
const _hoisted_16 = {
  key: 1,
  class: "form-group mt-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "order-comment" }, "Kommentar till butikschef:", -1))
const _hoisted_18 = { class: "row mt-2" }
const _hoisted_19 = { class: "col-sm-4 offset-sm-8" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.modalContent.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.modalContent.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeModal()), ["prevent"]))
                }, " × ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_ctx.modalContent.body), 1),
            (_ctx.modalContent.err)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.modalContent.err), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.modalContent.err)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showOrder()), ["prevent"]))
                }, " OK "))
              : _createCommentVNode("", true),
            (_ctx.modalContent.err)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.closeModal()), ["prevent"]))
                }, " OK "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.back())),
      class: "btn btn-link"
    }, " ← Tillbaka "),
    _hoisted_9,
    (_ctx.shoppingList)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.shoppingList.name), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoppingList.rows, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(row.text), 1),
                    _createElementVNode("td", null, _toDisplayString(row.amount), 1),
                    _createElementVNode("td", null, _toDisplayString(row.comment), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          (_ctx.shoppingList.comment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  id: "shopping-list-comment",
                  rows: "3",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shoppingList.comment) = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.shoppingList.comment]
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.order)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            id: "order-comment",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.order.comment) = $event)),
            rows: "3"
          }, null, 512), [
            [_vModelText, _ctx.order.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          disabled: _ctx.submittingOrder,
          class: "btn btn-primary d-block w-100"
        }, " Skicka in ", 8, _hoisted_20)
      ])
    ])
  ]))
}